export const MAP_CONSTANTS = {
  INIT_X: 40,
  INIT_Y: 25,
  INIT_Z: 0,
  PLANE_WIDTH: 3200,
  PLANE_HEIGHT: 1536,
  FRUSTUM_SIZE: 900,
  BARRIER: 100,
  ENTRY: 101
}

export const CAMERA_CONSTANTS = {
  INIT_X: -MAP_CONSTANTS.PLANE_WIDTH / 4,
  INIT_Y: -MAP_CONSTANTS.PLANE_HEIGHT / 4,
  INIT_Z: 100,
}

export const PLAYER_CONSTANTS = {
  INIT_X: -888,
  INIT_Y: -400,
  INIT_Z: 0,
  SCALE: 64,
  SPEED: 3,
  COLUMNS: 4,
  ROWS: 1,
}

export const GAME_CONSTANTS = {
  FRAME_HEIGHT: 1 / PLAYER_CONSTANTS.ROWS,
  FRAME_WIDTH: 1 / PLAYER_CONSTANTS.COLUMNS,
  FRAME_TIME: 100,
}